"use client";

import React from "react";
import dynamic from "next/dynamic";
import {
    HOW_IT_WORKS,
    HOW_IT_WORKS_FIRST_ROW,
    HOW_WE_WORK_TITLE,
} from "./constants";
import { PrismicRichText } from "@prismicio/react";
import HowItWorksIntlCard from "../../Molecules/HowItWorksIntlCard";
import {  usePathname } from "next/navigation";

const HowItWorkIntlSection = ({ slice, userCountry }) => {
    const route = usePathname();
    if(userCountry?.flag=='AE' && route=='/') return <></>
    return (
        <div id={HOW_IT_WORKS}>
            <PrismicRichText
                field={slice?.primary?.title}
                components={{
                    heading1: ({ children }) => (
                        <p className={HOW_WE_WORK_TITLE}>{children}</p>
                    ),
                }}
            ></PrismicRichText>
            <div className={HOW_IT_WORKS_FIRST_ROW}>
                {slice?.items?.map((item, index) => (
                    <HowItWorksIntlCard
                        key={index}
                        index={index}
                        heading={item?.title}
                        description={item?.description}
                        description2={item?.description2}
                        descriptionBold={item?.descriptionbold}
                        image={item?.image?.url}
                        userCountry={userCountry}
                    />
                ))}
            </div>
        </div>
    );
};

export default HowItWorkIntlSection;
